import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-u10",
  "use": "icon-u10-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-u10\">\n  <g transform=\"matrix(1 0 0 1 -36 -18 )\">\n    <path d=\"M 43 18  C 46.92 18  50 21.08  50 25  C 50 28.92  46.92 32  43 32  C 39.08 32  36 28.92  36 25  C 36 21.08  39.08 18  43 18  Z \" fill-rule=\"nonzero\" fill=\"#17387b\" stroke=\"none\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol